<template>
    <div>
        <b-overlay
            :show="dataOverlay"
            spinner-variant="success"
            no-wrap
        ></b-overlay>
        <div class="d-flex justify-content-start align-items-center mb-4">
            <div>
                <h5 class="m-0">Детали ТС <span class="text-secondary">{{items.number}}</span> (#{{items.id}})</h5>
            </div>
            <div class="ml-3">
                <b-badge variant="success" class="always-small-badge" v-if="items.checked_id == 444"><i class='bx bx-check'></i> ТС проверено!</b-badge>
                <b-badge variant="secondary" class="always-small-badge" v-if="items.checked_id == 443">ТС на проверке</b-badge>
                <b-badge variant="danger" class="always-small-badge" v-if="items.checked_id == 445">ТС не прошел проверку!</b-badge>
            </div>
        </div>
        <table class="table table-hover table-borderless table-fixed">
            <tbody>
                <tr>
                    <td class="table-title-details">Номер ТС</td>
                    <td>{{items.number || "Не указано"}}</td>
                </tr>
                <tr>
                    <td class="table-title-details">ТС закреплено в компаниях</td>
                    <td>
                        <template v-if="items.companies && items.companies.length > 0">
                            <ul class="disc-lists">
                                <template v-for="company in items.companies">
                                    <li>{{ company.name }} ({{ company.inn }})</li>
                                </template>
                            </ul>
                        </template>
                        <template v-else>
                            Пока не прикреплено ни к одной компании
                        </template>
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">Собственность</td>
                    <td>
                        {{typeOfOwnering(items.owner)}}
                        <template v-if="items.owner == 0">
                            <div class="mt-2">
                                <b>Договор аренды. Номер и дата: </b> {{items.rent_number || "Не указано"}}<br>
                                <template v-if="items.rent_file">
                                    <a :href="hfs+items.rent_file.path" target="_blank">Посмотреть договор аренды &raquo;</a>
                                </template>
                                <template v-else>
                                    <span class="text-danger">Договор аренды не приложен!</span>
                                </template>
                            </div>
                        </template>
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">Марка</td>
                    <td>
                        {{items.brand || "Не указан"}}
                        <template v-if="items.year">
                            / {{items.year}} г. (год выпуска)
                        </template>
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">Вид ТС</td>
                    <td>
                        {{items.truck_type ? items.truck_type.name : "Не указан"}}
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">Тип кузова ТС</td>
                    <td>
                        {{items.truck_body_type ? items.truck_body_type.name : "Не указан"}}
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">Габариты</td>
                    <td>
                        <template v-if="items.reference_truck_type_id == 430">
                            Грузоподъемность: {{items.carrying + " т." || "Не указан"}}
                        </template>
                        <template v-else>
                            <b>Длина х Ширина х Высота:</b> {{items.dimensions_length || 0}} х {{items.dimensions_width || 0}} х {{items.dimensions_height || 0}} м.<br>
                            <b>Объем кузова:</b>
                            <template v-if="items.dimensions_volume">
                                {{ items.dimensions_volume }} м<sup>3</sup>
                            </template>
                            <template v-else>
                                Не указан
                            </template><br>
                            <b>Грузоподъемность:</b> {{items.carrying + " т." || "Не указан"}}
                        </template>
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">Тип загрузки</td>
                    <td>
                        {{items.type_of_loading || "Не указан"}}
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">СТС. Серия и номер</td>
                    <td>
                        {{ items.ctc_number || "Не указан" }}
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">СТС. Сканы </td>
                    <td>
                        <div class="d-flex flex-row bd-highlight mb-3">
                            <div class="p-2 text-center">
                                <template v-if="items.ctc_file_face">
                                    <a :href="hfs+items.ctc_file_face.path" target="_blank"><img :id="'doc-logo-'+items.id" :src="'/img/icon-document.svg'" style="width: 60px;"></a>
                                    <div class="text-secondary font-weight-bold mt-2">Лицевая сторона</div>
                                </template>
                                <template v-else>
                                    <img :id="'doc-logo-'+items.id" :src="'/img/icon-document.svg'" style="width: 60px; opacity: 0.6;">
                                    <div class="text-secondary mt-2">Лицевая сторона<br><span class="text-danger">не приложена</span></div>
                                </template>
                            </div>
                            <div class="p-2 text-center">
                                <template v-if="items.ctc_file_back">
                                    <a :href="hfs+items.ctc_file_back.path" target="_blank"><img :id="'doc-logo-'+items.id" :src="'/img/icon-document.svg'" style="width: 60px;"></a>
                                    <div class="text-secondary font-weight-bold mt-2">Оборотная сторона</div>
                                </template>
                                <template v-else>
                                    <img :id="'doc-logo-'+items.id" :src="'/img/icon-document.svg'" style="width: 60px; opacity: 0.6;">
                                    <div class="text-secondary mt-2">Оборотная сторона<br><span class="text-danger">не приложена</span></div>
                                </template>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">ПТС. Серия и номер</td>
                    <td>
                        {{ items.ptc_number || "Не указан" }}
                    </td>
                </tr>
                <tr>
                    <td class="table-title-details">ПТС. Сканы </td>
                    <td>
                        <div class="d-flex flex-row bd-highlight mb-3">
                            <div class="p-2 text-center">
                                <template v-if="items.ptc_file_face">
                                    <a :href="hfs+items.ptc_file_face.path" target="_blank"><img :id="'doc-logo-'+items.id" :src="'/img/icon-document.svg'" style="width: 60px;"></a>
                                    <div class="text-secondary font-weight-bold mt-2">Лицевая сторона</div>
                                </template>
                                <template v-else>
                                    <img :id="'doc-logo-'+items.id" :src="'/img/icon-document.svg'" style="width: 60px; opacity: 0.6;">
                                    <div class="text-secondary mt-2">Лицевая сторона<br><span class="text-danger">не приложена</span></div>
                                </template>
                            </div>
                            <div class="p-2 text-center">
                                <template v-if="items.ptc_file_back">
                                    <a :href="hfs+items.ptc_file_back.path" target="_blank"><img :id="'doc-logo-'+items.id" :src="'/img/icon-document.svg'" style="width: 60px;"></a>
                                    <div class="text-secondary font-weight-bold mt-2">Оборотная сторона</div>
                                </template>
                                <template v-else>
                                    <img :id="'doc-logo-'+items.id" :src="'/img/icon-document.svg'" style="width: 60px; opacity: 0.6;">
                                    <div class="text-secondary mt-2">Оборотная сторона<br><span class="text-danger">не приложена</span></div>
                                </template>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import {
        API_TRUCKS,
        HOST_FOR_STORAGE
    } from '../../constants'

    export default {
        props: {
            itemId: { type: Number, required: false },
        },
        data() {
            return {
                api: API_TRUCKS,
                items: '',
                dataOverlay: true,
                hfs: HOST_FOR_STORAGE
            }
        },
        mounted() {
            this.getDriver(this.itemId)
        },
        methods: {
            getDriver(id){
                api.call('get', `${this.api}/${id}`).then(({data}) => {
                    this.items = data
                    this.dataOverlay = false
                })
            },
            typeOfOwnering(owner) {
                switch (owner) {
                    case 0:
                        return "Не в собственности"
                    case 1:
                        return "ТС в собственности"
                    default:
                        return "Не известно"
                }
            }
        }
    }
</script>
